import { useContext, useEffect, useState } from 'react';

import { Form as FormAntd, Radio } from 'antd';

import {
  ColSize,
  ConfirmationModal,
  ContentSection,
  Form,
  RowSize,
} from '../../../../../../../../../shared/components';
import { ModalDeleteTab, QuotationStepButtons } from '../../../../../shared';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import {
  GenericDataFormContext,
  QuotationInfoContext,
} from '../../../../../shared/contexts';
import { StepTwoFormContext } from '../../contexts/StepTwoForm/StepTwoFormContext';
import { WizardDataFormContext } from '../../../../Wizard/contexts/WizardDataForm';

import { PLAN_TYPE, QuotationStep } from '../../../../../shared/interfaces';

export const PropertyDataCivil = () => {
  const {
    activeKey,
    addNewTab,
    areTabActionsAllowed,
    civilFormValues,
    isPlanTypeADisabled,
    isPlanTypeCDisabled,
    keyTabToDelete,
    planTypeSelected,
    removeTab,
    resetTabs,
    setActiveKey,
    setCivilFormValues,
    setKeyTabToDelete,
    setPlanTypeSelected,
    setShowModal,
    showModal,
    stepTwoForm,
    tabs,
  } = useContext(StepTwoFormContext);
  const { handleTabErrors } = useContext(WizardDataFormContext);
  const { savedQuotation, setCurrentStep } = useContext(QuotationInfoContext);
  const { setCanShowSpinner, setUserCanDeleteTabs } = useContext(GenericDataFormContext);

  const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  const [unconfirmedPlanType, setUnconfirmedPlanType] = useState<
    PLAN_TYPE | null
  >(null);

  const handlePressTab = (newActiveKey: string) => {
    setActiveKey(newActiveKey);
  };

  const onValidateForm = async () => {
    try {
      setCanShowSpinner(true);
      await stepTwoForm?.validateFields();

      setCivilFormValues(stepTwoForm?.getFieldsValue());
      setUserCanDeleteTabs(false);
      setCurrentStep(QuotationStep.THREE);
    } catch (error: any) {
      if (error && error?.errorFields?.length > 0) {
        handleTabErrors(error?.errorFields, ['tab'], 'Responsabilidad Civil');
      }
    } finally {
      setCanShowSpinner(false);
    }
  };

  const handlerBackButton = () => {
    setCivilFormValues(stepTwoForm?.getFieldsValue());
    setCurrentStep(QuotationStep.ONE);
  };

  const onEdit = (targetKey: any, action: 'add' | 'remove') => {
    if (action === 'add') {
      addNewTab();
      return;
    }
    removeTab(targetKey);
  };

  const handleOk = () => {
    if (keyTabToDelete !== null) {
      removeTab(keyTabToDelete);
      setKeyTabToDelete(null);
    }
    setShowModal(false);
  };

  const handleCancel = () => {
    setShowModal(false);
    setKeyTabToDelete(null);
  };

  const handleChangePlanType = (e: any) => {
    setUnconfirmedPlanType(e.target.value);
    setShowConfirmationModal(true);
  };

  const handleCancelConfirmationModal = () => {
    setShowConfirmationModal(false);
  };

  const handleConfirmActionModal = () => {
    if (unconfirmedPlanType && unconfirmedPlanType !== planTypeSelected) {
      setPlanTypeSelected(unconfirmedPlanType);

      setCivilFormValues(null);

      resetTabs(unconfirmedPlanType);
    }
    setUnconfirmedPlanType(null);
    setShowConfirmationModal(false);
  };

  useEffect(() => {
    if (
      civilFormValues &&
      Object.keys(civilFormValues).length > 0 &&
      !savedQuotation
    ) {
      stepTwoForm?.setFieldsValue(civilFormValues);
    }
  }, [civilFormValues, stepTwoForm]);

  return (
    <>
      <Form formProps={{ form: stepTwoForm, name: 'property-data-civil-form' }}>
        <ContentSection level='h3' title='Tipo de Plan'>
          <RowSize>
            <ColSize size={100}>
              <FormAntd.Item label='Tipo de Plan: '>
                <Radio.Group
                  value={planTypeSelected}
                  onChange={(e) => handleChangePlanType(e)}
                >
                  <Radio value={PLAN_TYPE.OPEN} disabled={isPlanTypeADisabled}>
                    Abierto
                  </Radio>
                  <Radio
                    value={PLAN_TYPE.CLOSED}
                    disabled={isPlanTypeCDisabled}
                  >
                    Cerrado
                  </Radio>
                </Radio.Group>
              </FormAntd.Item>
            </ColSize>
          </RowSize>
        </ContentSection>

        {tabs.length > 0 && (
          <Tabs
            type='editable-card'
            activeKey={activeKey}
            onEdit={onEdit}
            hideAdd
            items={tabs}
            handlePressTab={handlePressTab}
          />
        )}
      </Form>

      <QuotationStepButtons
        label='Continuar'
        onClick={onValidateForm}
        onPressBackButton={handlerBackButton}
      />

      <ModalDeleteTab
        open={showModal}
        onCancel={handleCancel}
        onOk={handleOk}
      />

      <ConfirmationModal
        open={showConfirmationModal}
        onCancel={handleCancelConfirmationModal}
        onConfirm={handleConfirmActionModal}
        confirmButtonLabel='Confirmar'
        title='¿Desea cambiar el Tipo de Plan?'
        description='Si cambia el Tipo de Plan, los datos cargados de esta operación serán eliminados y tendrá que volver a cargar de vuelta todos los datos de la misma. ¿ Desea continuar ?'
      />
    </>
  );
};
